import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, ArrowUpRight } from "lucide-react";
import chirpwellLogo from "@/assets/chirpwell-logo.png";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTitle, SheetDescription, SheetTrigger } from "@/components/ui/sheet";
import { SITE_NAVIGATION } from "@/config/site";

const Header = () => {
  const { pathname, hash } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(false); }, [pathname, hash]);
  return (
    <header className="brand-header fixed inset-x-0 top-0 z-50 border-b">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:p-3 focus:bg-brand-surface">Skip to content</a>
      <div className="brand-container flex h-20 items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="Chirpwell home">
          <img src={chirpwellLogo} alt="" width={36} height={36} className="h-9 w-9 object-contain" />
          <span className="text-2xl font-semibold font-display">Chirpwell<span className="text-brand-gold">.</span></span>
        </Link>
        <nav aria-label="Main navigation" className="hidden lg:flex items-center gap-7">
          {SITE_NAVIGATION.map(item => <Link key={item.label} to={item.href} className={`text-sm font-semibold transition-colors hover:text-brand-sage ${pathname === '/' && hash === item.href.slice(1) ? 'text-brand-ink' : 'text-brand-muted'}`}>{item.label}</Link>)}
        </nav>
        <Button asChild variant="brand" className="hidden lg:inline-flex"><Link to="/#tools">Explore Free Tools <ArrowUpRight /></Link></Button>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild><Button variant="brandOutline" size="icon" className="lg:hidden" aria-label="Open navigation"><Menu /></Button></SheetTrigger>
          <SheetContent className="bg-brand-surface text-brand-ink border-brand-line">
            <SheetTitle className="text-brand-ink font-display">Chirpwell</SheetTitle>
            <SheetDescription className="text-brand-muted">Revenue intelligence & enablement</SheetDescription>
            <nav aria-label="Mobile navigation" className="mt-8 flex flex-col">
              {SITE_NAVIGATION.map(item => <Link key={item.label} to={item.href} onClick={() => setOpen(false)} className="border-b border-brand-line py-4 text-lg font-medium">{item.label}</Link>)}
            </nav>
            <Button asChild variant="brand" className="mt-8 w-full"><Link to="/cross-sell-simple" onClick={() => setOpen(false)}>Open Calculator <ArrowUpRight /></Link></Button>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
export default Header;
